import { CAC_PAYBACK_TREND, LTV_CAC_RATIO_TREND } from "./exampleData";
import MetricBarChart from "./MetricBarChart";

/** Single-series charts for the unit-economics metric family (LTV:CAC, payback). */

const ratio = (v: number) => `${v}:1`;
const mo = (v: number) => `${v} mo`;

export const LtvCacRatioChart = () => (
  <MetricBarChart
    caption="LTV:CAC climbs from 2.4:1 to 3:1 as acquisition gets cheaper against a steady $6,000 lifetime value — landing right on the classic healthy benchmark."
    data={LTV_CAC_RATIO_TREND}
    seriesName="LTV:CAC"
    format={ratio}
    reference={{ y: 3 }}
    domain={[0, 4]}
  />
);

export const CacPaybackChart = () => (
  <MetricBarChart
    caption="CAC payback eases from 16 to about 13 months — a $2,000 CAC recouped at $150 of gross margin per month. Under 12 is strong; over 24 is a warning."
    data={CAC_PAYBACK_TREND}
    seriesName="CAC payback"
    format={mo}
    domain={[0, "dataMax + 4"]}
  />
);
